/*
 *
 * Detects if the current platform is iOS
 * Example use:
 * platformIsIOS()
 * would return: boolean
*/
export function platformIsIOS() {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
}